import { useRef, useState } from 'react';
import useOutsideElement from 'components/Dashboard/utilities/useOutsideElement';
import normalize from 'components/Dashboard/utilities/normalizeString';

const SORT_OPTIONS = ['Status', 'Latest requested'];

const TranscriptsSort = ({ sortOrder, setSortOrder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const container = useRef(null);
  useOutsideElement(container, () => setIsOpen(false));

  return (
    <div className='position-relative filter-main-container' ref={container}>
      <button className={`sort-button ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        <span className='icon-sort'></span>
        Sort by: {sortOrder}
      </button>
      {isOpen && (
        <div
          className='box-shadow rounded position-absolute z-extra-max bg-white py-3 pr-4 pl-3'
          style={{ minWidth: 'max-content', right: 0, top: '38px' }}
        >
          {SORT_OPTIONS.map((option, index) => (
            <div className={`radio-button ${index === 0 ? 'mb-3' : 'mb-2'} `} key={option}>
              <input
                id={normalize(option)}
                type='radio'
                checked={sortOrder === option}
                onChange={() => {
                  setSortOrder(option);
                  setIsOpen(false);
                }}
              />
              <label htmlFor={normalize(option)}>{option}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TranscriptsSort;
